import { basicApi } from '../utils/api';

export interface MmsImage {
  fileId: string;
  name?: string;
  originalName?: string;
  url?: string;
  width?: number;
  height?: number;
  fileSize?: number;
}

const path = '/solapi/mms-images';

export const getMmsImage = async (fileId: string) =>
  (await basicApi.get<MmsImage>(`${path}/${encodeURIComponent(fileId)}`)).data;

export const uploadMmsImage = async (file: File) => {
  const body = new FormData();
  body.append('file', file);
  return (await basicApi.post<MmsImage>(path, body, { headers: { 'Content-Type': 'multipart/form-data' } })).data;
};
